module.exports = require('./components/ktoenquete');
